import { apiClient } from "@base/api/client";
import { type UseQueryOptions, useQuery } from "@tanstack/react-query";
import { type ProjectTagsResponse, projectTagsResponseSchema } from "./projectTagsSchema";

async function fetchProjectTags(projectId: string, keyword: string): Promise<ProjectTagsResponse> {
  const trimmed = keyword.trim();
  const response = await apiClient.get<unknown>(`/project-management/api/projects/${projectId}/tags`, {
    params: trimmed ? { keyword: trimmed } : undefined,
  });
  return projectTagsResponseSchema.parse(response.data);
}

export function projectTagsQueryOptions(projectId: string, keyword: string) {
  const trimmed = keyword.trim();
  return {
    queryKey: ["project-tags", projectId, trimmed] as const,
    queryFn: () => fetchProjectTags(projectId, keyword),
  };
}

export function useProjectTagsQuery(
  projectId: string,
  keyword: string,
  options?: Omit<UseQueryOptions<ProjectTagsResponse>, "queryKey" | "queryFn">,
) {
  return useQuery({
    ...projectTagsQueryOptions(projectId, keyword),
    ...options,
  });
}
